import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import panzoom from 'panzoom';
import Viewer from 'viewerjs';

@Component({
  selector: 'app-supportpdf-viewer',
  templateUrl: './supportpdf-viewer.component.html',
  styleUrls: ['./supportpdf-viewer.component.scss']
})
export class SupportpdfViewerComponent implements OnInit, AfterViewInit {
  srcFile:any;
  pdfUrl:any;
  isImgBoolean:boolean;
   zoom: number = 1;
   zoomdata: number = 0.7;
   isUpdated:boolean = false;
   @ViewChild('imageRef') imageElement!: ElementRef;

   viewer!: Viewer;
  constructor(
    private d_ref :MatDialogRef<SupportpdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if(this.data.file.includes('assets')){
      this.pdfUrl = this.data.file;
      this.srcFile = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
      this.isUpdated = true;
    } else {
      this.srcFile = this.data.file;
      this.isUpdated = false;
      let fileType = this.data.doc_name.split('.').pop();
      console.log(fileType);
      if(fileType == 'pdf'){
        this.isImgBoolean = false;
      } else {
        this.isImgBoolean = true;
        this.srcFile = this.sanitizer.bypassSecurityTrustResourceUrl(this.srcFile);
      }
    }
    // this.srcFile = this.data.file;
    console.log(this.data);
  }
  ngAfterViewInit() {
    // const element = document.getElementById('parentDiv');
    // if (element) {
    //   panzoom(element);
    // }
    this.viewer = new Viewer(this.imageElement.nativeElement, {
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        rotateLeft: true,
        rotateRight: true
      },
      rotatable: true,
      zoomable: true,
      movable: true,
      fullscreen: true,
      transition: true,
      inline: false 
    });
    this.viewer.show();
    console.log(this.viewer);
  }
}
